import WebViewer from "@pdftron/webviewer";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import { useTheme } from "@mui/material/styles";

const EditABFile = (props) => {
  const theme = useTheme();
  const viewRef = useRef();
  const params = useParams();
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;

  const loadABFile = async () => {

    try {
      const file = await OAuthService.getPostPdf(
        url + `/api/downloadAbFile/${params?.id}`
      );

      const blob = new Blob([file?.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      WebViewer(
        {
          path: 'lib',
          //   path: '/node_modules/@pdftron/webviewer/public/',
          initialDoc: blobUrl,
        },
        viewRef.current
      ).then((instance) => {
        instance.UI.setTheme(
          theme.palette.mode === "dark"
            ? "dark"
            : "light"
        );
        const { documentViewer, annotationManager, Annotations } = instance.Core;
        instance.UI.enableFeatures([instance.UI.Feature.ContentEdit]);
        instance.setToolbarGroup(instance.UI.ToolbarGroup.EDIT_TEXT);
        documentViewer.addEventListener('documentLoaded', () => {
          const rectangleAnnot = new Annotations.RectangleAnnotation({
            Author: annotationManager.getCurrentUser()
          });

          annotationManager.addAnnotation(rectangleAnnot);
          annotationManager.redrawAnnotation(rectangleAnnot);
        });
      });
    } catch (error) { }
  }

  useEffect(() => {
    loadABFile();
  }, [])

  return (
    <div ref={viewRef} style={{ height: '100vh' }}></div>
  )
}

export default EditABFile;